import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-integer-range-selector',
  templateUrl: './integer-range-selector.component.html',
  styleUrls: ['./integer-range-selector.component.scss'],
})
export class IntegerRangeSelectorComponent {
  @ViewChild('detailsGroup') detailsGroup!: ElementRef<HTMLDetailsElement>;

  @Input() label: string = 'Intervalo';
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() showError: boolean = false;
  @Input() limit: number | null = null;

  @Output() minChange = new EventEmitter<number | null>();
  @Output() maxChange = new EventEmitter<number | null>();

  isOpen: boolean = false;

  constructor(private elementRef: ElementRef) {}

  get hasValue(): boolean {
    return this.min !== null || this.max !== null;
  }

  get displayValue(): string {
    if (this.min !== null && this.max !== null) {
      return `${this.min} - ${this.max}`;
    } else if (this.min !== null) {
      return `A partir de ${this.min}`;
    } else if (this.max !== null) {
      return `Até ${this.max}`;
    }
    return '';
  }

  onToggle(event: Event) {
    const details = event.target as HTMLDetailsElement;
    this.isOpen = details.open;
  }

  get hasLogicError(): boolean {
    if (this.min !== null && this.max !== null) {
      return this.min > this.max;
    }
    return false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (this.detailsGroup && this.detailsGroup.nativeElement.open) {
        this.detailsGroup.nativeElement.open = false;
      }
    }
  }

  onMinChange() {
    if (!this.limit) {
      return this.minChange.emit(this.min);
    }

    if (this.min && this.limit > this.min) {
      return this.minChange.emit(this.min);
    }

    setTimeout(() => {
      const cappedValue = Number(this.min?.toString().slice(0, 5)) || null;
      this.min = cappedValue;
      this.minChange.emit(cappedValue);
    });
  }

  onMaxChange() {
    if (!this.limit) {
      return this.maxChange.emit(this.max);
    }

    if (this.max && this.limit > this.max) {
      return this.maxChange.emit(this.max);
    }

    setTimeout(() => {
      const cappedValue = Number(this.max?.toString().slice(0, 5)) || null;
      this.max = cappedValue;
      this.maxChange.emit(cappedValue);
    });
  }

  preventNonNumericalInput(event: KeyboardEvent) {
    const forbiddenKeys = ['e', 'E', '.', ',', '+', '-'];

    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}
